import { Accordion, AccordionDetails, AccordionSummary, Alert, Autocomplete, Box, Button, Collapse, Grid, IconButton, InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";

import { useParams } from "react-router-dom";
import { NumberFormatMoney } from "../useForm";
import format from 'format-number'
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const columns = [
    { id: 'proyecto', label: 'Proyecto', width: 150, align: 'justify' },
    { id: 'partida', label: 'Partida', width: 150, align: 'justify' },
    { id: 'monto', label: 'Monto', width: 150, align: 'right' }
];

export default function TransferenciaDestino(props) {
    const token = sessionStorage.getItem('token')
    const decoded = jwt_decode(token);
    const idResponsable = decoded.id;
    const [anio, setAnio] = useState(null)
    const [proyectos, setProyectos] = useState([])
    const [proyectosRespaldo, setProyectosRespaldo] = useState([])
    const [entidad, setEntidad] = useState(null)
    //const [partidas, setPartidas] = useState([]);
    const [fechas, setFechas] = useState(null)
    const [partidasProyecto, setPartidasProyecto] = useState([])
    
    const [id, setId] = useState(null);
    const [justificacion, setJustificacion] = useState('');
    const [observaciones, setObservaciones] = useState('');
    const [sinConfiguracionFechas, setSinConfiguracionFechas] = useState(false)
    const [monto, setMonto] = useState(null);
    const [errorMonto, setErrorMonto] = useState(false)
    const [helperTextMonto, setHelperTextMonto] = useState('')
    const [errorProyectoSinPartidas, setErrorProyectoSinPartidas] = useState(false)
    const [helperTextProyectoSinPartidas, setHelperTextProyectoSinPartidas] = useState('')
    const [errorPartidaRepetida, setErrorPartidaRepetida] = useState(false)
    const [helperTextPartidaRepetida, setHelperTextPartidaRepetida] = useState('')
    const [errorEntidadSinProyectos, setEntidadSinProyectos] = useState(false)
    const [transferenciaOrigens, setTransferenciaOrigens] = useState([])
    const [transferenciaDestino, setTransferenciaDestino] = useState(props.destino)
    // console.log(`props.destino ${JSON.stringify(props.destino)}`)
    const [transferenciasEliminadas, setTransferenciasEliminadas] = useState([])
    const [open, setOpen] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [expiroFecha, setExpiroFecha] = useState(false)
    const solicitud = props.solicitud;
    const [proyecto, setProyecto] = useState(null);
    const [partida, setPartida] = useState(null)
    const [indice, setIndice] = useState(1);
    const [severity, setSeverity] = useState('error')
    const { transferenciasDestino, setTransferenciasDestino, idSolicitud, handleUpdateDestino, handleDeleteDestino, handleDeleteOrigen, partidasModificadas, setPartidasModificadas, verificarDisponible } = props;

    const params = useParams()

    useEffect(() => {
        setTransferenciaDestino(props.destino);
        setTransferenciaOrigens(props.destino.transferenciaOrigens)
    }, [props.destino]);

    const cargarProyectos = async () => {

        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/informeProyecto/proyectos/${params.idResponsable ? params.idResponsable : solicitud ? solicitud.idSolicitante : idResponsable}/${false}/${sessionStorage.getItem('idEntidad')}`, { //Siempre es en gestión por eso se pone false
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        if (res.status === 404) {
            //console.log('regresó 404 en Transferencia')poner mensaje de error
            return
        }
        else {
            //console.log('si hay proyectos')
            const data = await res.json()
            //console.log(data)

            setProyectos(data)
            setProyectosRespaldo(data)

            const idPlan = data[0].idPlan
            //console.log(`IDPLAN ${data[0].idPlan}`)
            const resPlan = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/${idPlan}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            }
            )
            const plan = await resPlan.json()
            //console.log(`ANIO ${plan.anio}`)
            setAnio(plan.anio)
            await cargarFechas(plan.anio)
        }
    }

    const cargarFechas = async (anio) => {

        //console.log(`ENTIDAD ${sessionStorage.getItem('idEntidad')}`)
        const entidad = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/entidad/${sessionStorage.getItem('idEntidad')}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        const entidadLeida = await entidad.json()
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/configuracionFechas/configuracion/${anio}/${entidadLeida.idEntidadSuperior ? entidadLeida.idEntidadSuperior : entidadLeida.id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        const fechasLeidas = await res.json()
        if (res.status === 404) {
            setMensaje('Aún no se ha establecido la configuración de fechas, solicite a la Asistencia Administrativa que la registre')
            setOpen(true)
            setSinConfiguracionFechas(true)
        }
        //console.log(`FECHAS LEIDAS ${fechasLeidas.activarMontosPrioridad2}`)
        setFechas(fechasLeidas)
        const fechaCierreTransferencias = new Date(fechasLeidas.cierreTransferencias)
        fechaCierreTransferencias.setDate(fechaCierreTransferencias.getDate() + 1);
        //console.log(`fechaCierreTransferencias ${fechaCierreTransferencias}`)                            
        if (Date.now() >= Date.parse(fechaCierreTransferencias)) {//console.log(`Entró a true ${Date.now()} --- ${Date.parse(fechaCierreTransferencias)}` )
            setExpiroFecha(true)
        }
        else {
            //console.log('entró a false')
            setExpiroFecha(false)
        }
    }

    useEffect(() => {
        (async () => {

            /* if (idSolicitud) {
                 const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/transferencias/solicitudTransferencias/${idSolicitud}`, {
                     method: "GET",
                     headers: {
                         "Content-Type": "application/json",
                         "x-access-token": sessionStorage.getItem('token'),
                         "perfil": sessionStorage.getItem('perfil')
                     }
                 })
                 const solicitud = await res.json()
 
                 let montoOrigenes = 0
                 await Promise.all(destino.transferenciaOrigens.map(async (transferencia) => {
                     const resPartida = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/${transferencia.idPartidaProyecto}`, {
                         method: "GET",
                         headers: {
                             "Content-Type": "application/json",
                             "x-access-token": sessionStorage.getItem('token'),
                             "perfil": sessionStorage.getItem('perfil')
                         }
                     })
                     transferencia.partida = await resPartida.json()
                     montoOrigenes = (Number(montoOrigenes) + Number(transferencia.monto)).toFixed(2)
                     const resProyecto = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proyectosPlan/proyecto/${transferencia.partida.idProyectoPlan}`, {
                         method: "GET",
                         headers: {
                             "Content-Type": "application/json",
                             "x-access-token": sessionStorage.getItem('token'),
                             "perfil": sessionStorage.getItem('perfil')
                         }
                     })
                     
                     transferencia.proyecto = await resProyecto.json()
                     
                 }))
                 
                 destino.monto = montoOrigenes                
                 
                 console.log(`destino.transferenciaOrigens ${JSON.stringify(destino.transferenciaOrigens)}`)
                 setTransferenciaOrigens(destino.transferenciaOrigens)
                 console.log(`solicitud en Destinos ${JSON.stringify(solicitud)}`)
 
                 setSolicitud(solicitud)
             }*/
            //console.log(`props.destino.transferenciaOrigens ${props.destino.transferenciaOrigens}`)
            if (props.destino.transferenciaOrigens)
                setTransferenciaOrigens(props.destino.transferenciaOrigens)

            await cargarProyectos()
        })()
        // eslint-disable-next-line
    }, [idSolicitud])

    /*const handleSolicitarTransferencia = async (e) => {
        e.preventDefault()
        if (idSolicitud) {
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/transferencias/${idSolicitud}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                },
                body: JSON.stringify({
                    idSolicitud,
                    idSolicitante: idResponsable,
                    anio,
                    transferenciasOrigen,

                    transferenciasEliminadas,
                    partida: transferenciaDestino.partida,
                    idEntidad: sessionStorage.getItem('idEntidad'),
                    seEnviaCorreo
                })
            })
            if (res.status === 200)
                setSeverity('success')
            else
                setSeverity('error')
            console.log(`TRANSFERENCIAS MODIFICADAS ${JSON.stringify({
                idSolicitud,
                idSolicitante: idResponsable,
                anio,
                transferenciasOrigen,
            })}`)
            const data = await res.json()
            if (data.message) {
                setOpen(true)
                setMensaje(data.message)
                return
            }
            else {
                setOpen(true)
                setMensaje("Se actualizó la solicitud")
            }
        }
        else {

            await Promise.all(transferenciasOrigen.map(async (transferencia) => {
                transferencia.id = null
            }))


            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/transferencia`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                },
                body: JSON.stringify({
                    idSolicitante: idResponsable,
                    anio,
                    transferenciasOrigen,
                    idEntidad: sessionStorage.getItem('idEntidad'),
                    seEnviaCorreo
                })
            })


            const data = await res.json()
            if (res.status === 200) {
                setSeverity('success')
                setTransferenciaOrigens([])
                setIdSolicitud(data.solicitud.id)
            }
            else
                setSeverity('error')
            if (data.message) {
                setOpen(true)
                setMensaje(data.message)
                return
            }
            else {
                setOpen(true)
                setMensaje("Se registró la solicitud")
            }
        }
    }*/

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!errorPartidaRepetida) {
            proyecto.partidaProyectos = null
            setPartidasModificadas([...partidasModificadas, { id: partida.idPartidaProyecto, monto }])
            const transferenciaOrigen = { id, monto, idPartidaProyecto: partida.idPartidaProyecto, partida: { ...partida }, proyecto: { ...proyecto } }
            //console.log(`errorPartidaRepetida ${errorPartidaRepetida} !errorPartidaRepetida ${!errorPartidaRepetida}`)
            if (idSolicitud && transferenciaOrigen.id) {
                const index = transferenciaOrigens.findIndex(transferenciasOrigen => String(transferenciasOrigen.id) === String(transferenciaOrigen.id));
                //console.log(`INDEX ${index}`)
                // OJO transferenciaOrigen.id = transferenciasOrigen[index].id
                if (index !== -1)
                    transferenciaOrigens.splice(index, 1);
                // setTransferenciasOrigen(transferenciasOrigen.filter(transferenciasOrigen => transferenciasOrigen.idPartidaProyecto !== transferenciaOrigen.idPartidaProyecto))
                transferenciaOrigens.push(transferenciaOrigen)
                setHelperTextPartidaRepetida('')
                setErrorPartidaRepetida(false)
            }
            else {
                if (transferenciaOrigen.id === null) {
                    transferenciaOrigen.id = `id${indice}`
                    setIndice(indice + 1)
                }
                const index = transferenciaOrigens.findIndex(transferenciaOrigens => String(transferenciaOrigens.id) === String(transferenciaOrigen.id));
                //console.log(`INDEX ${index}`)
                // OJO transferenciaOrigen.id = transferenciasOrigen[index].id
                if (index !== -1)
                    transferenciaOrigens.splice(index, 1);
                transferenciaOrigens.push({ ...transferenciaOrigen })
            }

            let montoAcumulado = Number(0)
            await Promise.all(transferenciaOrigens.map(async (transferencia) => {
                montoAcumulado = (Number(montoAcumulado) + Number(transferencia.monto)).toFixed(2)
            }))
            setTransferenciaDestino({ ...transferenciaDestino, monto: montoAcumulado })

            //transferenciaDestino.transferenciasOrigen = transferenciasOrigen
            const destino = transferenciasDestino.filter(transferencia => transferencia.idPartidaProyecto === transferenciaDestino.idPartidaProyecto)[0]
            destino.monto = montoAcumulado
            destino.transferenciaOrigens = transferenciaOrigens
            //console.log(`destino ${JSON.stringify(destino)}`)
            setTransferenciasDestino([...transferenciasDestino])
            setMonto(null)
            setId(null)
            setEntidad(null)
            setJustificacion('')
            setObservaciones('')
            setPartida(null)
            //setPartidasProyecto([])
        }
    }

    const handleDelete = async (registro) => {
        //console.log(`registro ${JSON.stringify(registro)}`)
        setTransferenciaOrigens(transferenciaOrigens.filter(transferenciasOrigen => Number(transferenciasOrigen.idPartidaProyecto) !== Number(registro.idPartidaProyecto)))
        setTransferenciaDestino({ ...transferenciaDestino, monto: Number(transferenciaDestino.monto) - Number(registro.monto) })
        //console.log(`registro.id ${registro.id}`)
        transferenciasEliminadas.push(registro.id)
        const destino = transferenciasDestino.filter(transferencia => transferencia.idPartidaProyecto === transferenciaDestino.idPartidaProyecto)[0]
        destino.monto = Number(destino.monto) - Number(registro.monto)
        destino.transferenciaOrigens = transferenciaOrigens.filter(transferenciaOrigens => Number(transferenciaOrigens.idPartidaProyecto) !== Number(registro.idPartidaProyecto))
        //console.log(`destino ${JSON.stringify(destino)}`)
        setTransferenciasDestino([...transferenciasDestino])
        setHelperTextPartidaRepetida('')
        setErrorPartidaRepetida(false)
    }

    const cargarPartidasProyecto = async (proyecto) => {
        if (proyecto) {
            const res2 = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/proyecto/${proyecto.id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            })
            const partidasPreprocesar = await res2.json()
            const partidasProyectoLectura = partidasPreprocesar.map((partida) => {
                const cantidades = partidasModificadas.filter(partidaM => Number(partidaM.id) === Number(partida.idPartidaProyecto))
                let total = Number(0)
                cantidades.map((cantidad)=>{
                    total += Number(cantidad.monto)
                    //console.log(`cantidad.monto ${cantidad.monto}`)
                })
                //console.log(`partida.prioridad1Disponible ${partida.prioridad1Disponible}`)
                //console.log(`Total ${total}`)
                partida.prioridad1Disponible = (Number(partida.prioridad1Disponible) - Number(total)).toFixed(2)
                //console.log(`partida.prioridad1Disponible ${partida.prioridad1Disponible}`)
                return partida
            })
            //console.log(`partidasProyectoLectura ${JSON.stringify(partidasProyectoLectura)}`)
            //Mostrar sólo las no 5000
            //console.log(`transferenciasDestino.clave ${JSON.stringify(transferenciasDestino[0].partida.clave)}`)
            if (transferenciaDestino) {
                if (4999999 < transferenciaDestino.partida.clave && transferenciaDestino.partida.clave < 60000000) {
                    setPartidasProyecto(partidasProyectoLectura)
                    //console.log(`sin filtrar ${partidasProyecto}`)
                }
                else {
                    setPartidasProyecto(partidasProyectoLectura.filter(partidasProyectoLectura => partidasProyectoLectura.clave < 5000000 || partidasProyectoLectura.clave > 5999999))
                    //console.log(`filtrado ${partidasProyecto}`)
                }
            }
            else {
                setPartidasProyecto(partidasProyectoLectura)
                //console.log(`partidasProyecto ${JSON.stringify(partidasProyecto)}`)
            }
            if (partidasProyectoLectura && partidasProyectoLectura.length > 0) {
                setErrorProyectoSinPartidas(false)
                setHelperTextProyectoSinPartidas('')
            }
            else {
                setErrorProyectoSinPartidas(true)
                setHelperTextProyectoSinPartidas('Este proyecto no tiene partidas')
            }
        }
    }

    const handleUpdate = async (transferencia) => {
        const resPartida = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/${transferencia.idPartidaProyecto}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        transferencia.partida = await resPartida.json()
        //console.log(`transferencia.partida ${JSON.stringify(transferencia.partida)}`)
        // Se actualiza el monto disponible de la partida para que esté disponible y poder modificarlo
        setPartida({ ...transferencia.partida, prioridad1Disponible: (Number(transferencia.partida.prioridad1Disponible) + Number(transferencia.monto)).toFixed(2) })
        //Variable disponible en todas las TranferenciaDestino para ajustar el momnto disponible cuando se leen las partidas de un proyecto seleccionado
        setPartidasModificadas([...partidasModificadas, { id: transferencia.idPartidaProyecto, monto: -(Number(transferencia.monto)) }])
        ///falta poner la partida con setPartida
        const resProyecto = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proyectosPlan/proyecto/${transferencia.partida.idProyectoPlan}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        transferencia.proyecto = await resProyecto.json()
        setProyecto({ ...transferencia.proyecto })
        await cargarPartidasProyecto(transferencia.proyecto)

        //setPartida(partidasLeidas.filter(partida => Number(partida.idPartidaProyecto) === Number(transferencia.partida.idPartidaProyecto)[0]))
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/entidad/${transferencia.proyecto.idEntidad}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })

        const entidad = await res.json()

        setEntidad(entidad)
        setJustificacion(transferencia.justificacion)
        setObservaciones(transferencia.observaciones)
        setMonto(transferencia.monto)
        setId(transferencia.id)
    }

    return (
        <>
            <Accordion expanded={transferenciaDestino.expanded} >
                <AccordionSummary className="encabezado-accordion"
                    expandIcon={<Button style={{ textTransform: 'none' }} className='boton-accordion' onClick={() => { setTransferenciaDestino({ ...transferenciaDestino, expanded: !transferenciaDestino.expanded }) }}>
                        {transferenciaDestino.expanded ? '' : 'Abrir'}
                        <ExpandMoreIcon />
                    </Button>}
                >
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={3}>
                            <strong>Entidad destino: </strong> {transferenciaDestino.entidad.nombre}
                        </Grid>
                        <Grid item xs={12} sm={3}><strong>Proyecto destino:</strong> {transferenciaDestino.proyecto.clave}-{transferenciaDestino.proyecto.descripcion}</Grid>
                        <Grid item xs={12} sm={3}><strong>Partida destino:</strong> {transferenciaDestino.partida.clave}-{transferenciaDestino.partida.concepto}</Grid>
                        <Grid item xs={12} sm={3}><strong>Monto:</strong> {Number(transferenciaDestino.monto).toLocaleString("es-MX", { style: "currency", currency: "MXN" })}</Grid>
                        {transferenciaDestino.justificacion ?
                            <Grid item xs={12}><strong>Justificación:</strong> {transferenciaDestino.justificacion}</Grid> :
                            <></>}
                        {transferenciaDestino.observaciones ?
                            <Grid item xs={12}><strong>Observaciones:</strong> {transferenciaDestino.observaciones}</Grid> :
                            <></>}
                        <Grid item xs={12}>
                            <Button type="button" variant="contained" style={{ color: '#b22dca', backgroundColor: 'whitesmoke' }} onClick={(e) => { e.stopPropagation(); handleUpdateDestino(transferenciaDestino) }}>Modificar</Button>
                            <Button type="button" variant="contained" style={{ color: '#b22dca', backgroundColor: 'whitesmoke', marginLeft: 5 }} onClick={(e) => { e.stopPropagation(); handleDeleteDestino(transferenciaDestino) }}>Eliminar</Button>

                            <Box sx={{ width: '100%' }}>
                                <Collapse in={false}>
                                    <Alert severity='info'
                                        action={
                                            <IconButton
                                                aria-label="close"
                                                color="inherit"
                                                size="small"
                                            >
                                                <CloseIcon fontSize="inherit" />
                                            </IconButton>
                                        }
                                        style={{ marginTop: 30 }}
                                    >
                                        prueba
                                    </Alert>
                                </Collapse>
                            </Box>
                        </Grid>
                    </Grid>
                </AccordionSummary>
                <AccordionDetails>
                    {transferenciaOrigens && transferenciaOrigens.length > 0 ?
                        <TableContainer sx={{ maxHeight: 440 }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow key='encabezado'>
                                        <TableCell key='ninguna' align="center" colSpan={5}>
                                            Partidas de origen
                                        </TableCell>
                                    </TableRow>
                                    <TableRow key='encabezado2'>
                                        {columns.map((column) => (
                                            <TableCell
                                                key={column.id}
                                                align={column.align}
                                                style={{ top: 57, minWidth: column.minWidth }}
                                            >
                                                {column.label}
                                            </TableCell>
                                        ))}<TableCell style={{ top: 57 }}></TableCell>
                                        <TableCell style={{ top: 57 }}></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {transferenciaOrigens.length > 0 ? transferenciaOrigens
                                        .map((row) => {
                                            return (
                                                <TableRow hover role="checkbox" tabIndex={-1} key={row.partida.idPartidaProyecto}>
                                                    {columns.map((column) => {
                                                        const value = row[column.id];
                                                        let partidaMostrar = ''
                                                        let proyectoMostrar = ''
                                                        if (column.id === 'partida')
                                                            partidaMostrar = `${value.clave}-${value.concepto}`
                                                        if (column.id === 'proyecto')
                                                            proyectoMostrar = `${value.clave}-${value.descripcion}`
                                                        return (
                                                            <TableCell key={column.id} align={column.align}>
                                                                {column.id === 'partida' ? partidaMostrar : (column.id === 'proyecto' ? proyectoMostrar : format({ prefix: '$' })(value))}
                                                            </TableCell>
                                                        );
                                                    })}
                                                    <TableCell><Button variant='contained' style={{ marginLeft: 5, backgroundColor: 'rgb(224, 224, 224)', color: 'rgba(0, 0, 0, 0.87)' }} onClick={(e) => { e.stopPropagation(); handleUpdate(row) }}>{'Editar'}</Button></TableCell>
                                                    <TableCell>
                                                        <Button variant='contained' style={{ marginLeft: 5, backgroundColor: "darkred", color: 'white' }} onClick={(e) => {
                                                            e.stopPropagation()
                                                            setPartidasModificadas([...partidasModificadas, { id: row.idPartidaProyecto, monto: -(Number(row.monto)) }])
                                                            if (row.id.includes('id'))
                                                                handleDelete(row)
                                                            else
                                                                handleDeleteOrigen(row)
                                                        }}>{'Eliminar'}
                                                        </Button>
                                                    </TableCell>

                                                </TableRow>
                                            );
                                        }) : <TableRow hover role="checkbox" tabIndex={-1} >

                                        <TableCell align='center'>
                                            No hay partidas para transferir registradas
                                        </TableCell>

                                    </TableRow>}
                                </TableBody>
                            </Table>
                        </TableContainer> : <></>
                    }
                    <form onSubmit={handleSubmit}>
                        <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
                            <Grid item xs={12} sm={4}>
                                {!errorEntidadSinProyectos ?
                                    <>
                                        <Autocomplete
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            getOptionLabel={(option) => option.clave + '-' + option.descripcion}
                                            value={proyecto ? proyecto : null}
                                            onChange={async (event, newValue) => {
                                                // console.log(newValue)
                                                setProyecto(newValue)
                                                setPartida(null)
                                                await cargarPartidasProyecto(newValue)

                                            }}
                                            name="proyecto"
                                            options={proyectos}
                                            sx={{ width: '100%' }}
                                            renderInput={(params) => <TextField {...params} label={`Proyecto origen`} focused required helperText={helperTextProyectoSinPartidas} error={errorProyectoSinPartidas} multiline />}
                                        />
                                    </>
                                    : <></>}
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                {partidasProyecto && partidasProyecto.length > 0 ?
                                    <Autocomplete
                                        isOptionEqualToValue={(option, value) => Number(option.id) === Number(value.id)}
                                        getOptionLabel={(option) => option.clave + '-' + option.concepto}
                                        value={partida ? partida : null}
                                        onChange={async (event, newValue) => {
                                            //console.log(`newValue ${newValue}`)                                           
                                            setPartida(newValue)
                                            setHelperTextPartidaRepetida('')
                                            setErrorPartidaRepetida(false)
                                            setErrorMonto(false)
                                            setHelperTextMonto('')
                                            setMonto('')
                                            if(Number(transferenciaDestino.partida.idPartidaProyecto)===Number(newValue.idPartidaProyecto)){
                                                setHelperTextPartidaRepetida('Esa partida es la de destino.')
                                                setErrorPartidaRepetida(true)
                                            }
                                            else{
                                                setHelperTextPartidaRepetida('')
                                                setErrorPartidaRepetida(false)
                                            }
                                            //console.log(`Antes de promise errorPartidaRepetida ${errorPartidaRepetida} !errorPartidaRepetida ${!errorPartidaRepetida}`)
                                            await Promise.all(transferenciaOrigens.map(async (transferencia) => {
                                                if (transferencia.idPartidaProyecto === newValue.idPartidaProyecto) {
                                                    setHelperTextPartidaRepetida('Esa partida ya se seleccionó')
                                                    setErrorPartidaRepetida(true)
                                                    return
                                                    //console.log(`Dentro de promise errorPartidaRepetida ${errorPartidaRepetida} !errorPartidaRepetida ${!errorPartidaRepetida}`)
                                                }
                                            }))

                                            

                                        }}
                                        name="partida"
                                        options={partidasProyecto}
                                        sx={{ width: '100%' }}
                                        renderInput={(params) => <TextField {...params} label={`Partida de origen`} focused required helperText={helperTextPartidaRepetida} error={errorPartidaRepetida} multiline />}
                                    />
                                    : <></>}

                            </Grid>
                            {partida && partidasProyecto && partidasProyecto.length > 0 ?
                                <>
                                    <Grid item xs={12} sm={4}>
                                        <TextField name='monto' label="Monto" required onChange={(e) => {
                                            const valor = e.target.value
                                            const valorNumerico = Math.abs(valor.replace(/,/g, ''))
                                            const fechaPrioridad2 = new Date(fechas.activarMontosPrioridad2)
                                            fechaPrioridad2.setDate(fechaPrioridad2.getDate() + 1);
                                            let montoDisponible = Number(partida.prioridad1Disponible)
                                            if (Date.now() >= Date.parse(fechaPrioridad2)) {
                                                montoDisponible += Number(partida.prioridad2Disponible)
                                            }
                                           // console.log(`fecha prioridad 2 ${fechaPrioridad2}`)
                                            setMonto(valorNumerico)
                                            if (verificarDisponible() && Number(valorNumerico) > Number(montoDisponible)) {
                                                setErrorMonto(true)
                                                setHelperTextMonto(`No debe exceder el monto disponible de la partida ${format({ prefix: '$' })(montoDisponible)}`)
                                            }
                                            else {
                                                setErrorMonto(false)
                                                setHelperTextMonto('')
                                            }
                                            //console.log(`ErrorMonto ${errorMonto} valor ${valorNumerico} partida.montoDisponible ${montoDisponible}`)
                                        }} InputProps={{
                                            inputComponent: NumberFormatMoney,
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    $
                                                </InputAdornment>
                                            ),
                                        }} value={monto} helperText={helperTextMonto} error={errorMonto} sx={{ width: '100%' }} />
                                    </Grid>
                                    <Grid item>
                                        <Button variant='contained' color='primary' type='submit' disabled={errorMonto || !monto || monto === 0 || errorPartidaRepetida}>
                                            Guardar origen
                                        </Button>
                                        <Button type='reset' variant='contained' color='error' style={{marginLeft: 5}} onClick={(e) => {
                                            e.stopPropagation();
                                            if (id)
                                                setPartidasModificadas([...partidasModificadas, { id: partida.idPartidaProyecto, monto }])
                                            setPartida(null); setMonto(null); setId(null); setProyecto(null); setJustificacion('');
                                            setObservaciones(''); setPartidasProyecto([]);
                                        }}>Limpiar</Button>
                                    </Grid>
                                </>
                                : <></>}
                        </Grid>
                    </form>
                </AccordionDetails>
            </Accordion>
            <Box sx={{ width: '100%' }}>
                <Collapse in={open}>
                    <Alert severity={severity}
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpen(false);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        style={{ marginTop: 30 }}
                    >
                        {mensaje}
                    </Alert>
                </Collapse>
            </Box>
        </>
    )
}
